import { existDFI_client } from "./existDFI_client";
import { optanon_groups_set, storeOptanonValuesCookie } from "./ringpool";

export function removeSpaces(str) {
  if (typeof str !== 'string') {
    throw new Error('Input must be a string');
  }
  
  return str.replace(/\s/g, '');
}

export function addSpaces(str) {
  if (typeof str !== 'string') {
    throw new Error('Input must be a string');
  }

  const regex = /(.{3})(?!$)/g;
  return str.replace(regex, '$1');
}


export function searchElements(dataOptanon) {
    var classesToSearch = ['drp_ring_container'];
  
    // Función para comprobar si un elemento contiene alguna de las clases buscadas
    function containsClass(element) {
      for (var i = 0; i < classesToSearch.length; i++) {
        if (element.classList.contains(classesToSearch[i])) {
          return true;
        }
      }
      return false;
    }

  
    // Realizar búsqueda sin el observador
    var elements = document.querySelectorAll('.' + classesToSearch.join(', .'));
    if (elements.length > 0) {
      console.log("Se encontraron elementos con las clases buscadas:", elements);
      
      storeOptanonValuesCookie(dataOptanon)
      optanon_groups_set()
    } else {
      // Crear un observador de mutaciones
      var observer = new MutationObserver(function(mutationsList, observer) {
        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var addedNode = mutation.addedNodes[j];
            if (addedNode.nodeType === Node.ELEMENT_NODE && containsClass(addedNode)) {
              console.log("Se encontró un elemento con una de las clases buscadas:", addedNode);
              
              storeOptanonValuesCookie(dataOptanon)
              optanon_groups_set()
              observer.disconnect();
              return;
            }
          }
        }
      });
  
      // Configuración del observador
      var observerConfig = {
        childList: true,
        subtree: true
      };
  
      // Comenzar la observación
      observer.observe(document.body, observerConfig);
  
      // Detener la observación después de 5 segundos (por ejemplo)
      setTimeout(function() {
        observer.disconnect();
      }, 5000);
    }
  }
  
  export function removeElements() {
    var classesToSearch = ['drp_ring_container'];
  
    // Función para comprobar si un elemento contiene alguna de las clases buscadas
    function containsClass(element) {
      for (var i = 0; i < classesToSearch.length; i++) {
        if (element.classList.contains(classesToSearch[i])) {
          return true;
        }
      }
      return false;
    }
  
    // Función para eliminar las clases de los elementos
    function removeClasses(elements) {
      for (var i = 0; i < elements.length; i++) {
        for (var j = 0; j < classesToSearch.length; j++) {
          elements[i].classList.remove(classesToSearch[j]);
        }
      }
    }
  
    // Realizar búsqueda sin el observador
    var elements = document.querySelectorAll('.' + classesToSearch.join(', .'));
    if (elements.length > 0) {
      console.log("Se encontraron elementos con las clases buscadas:", elements);
      removeClasses(elements);
    } else {
      // Crear un observador de mutaciones
      var observer = new MutationObserver(function (mutationsList, observer) {
        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var addedNode = mutation.addedNodes[j];
            if (addedNode.nodeType === Node.ELEMENT_NODE && containsClass(addedNode)) {
              console.log("Se encontró un elemento con una de las clases buscadas:", addedNode);
              removeClasses(elements);
              observer.disconnect();
              return;
            }
          }
        }
      });
  
      // Configuración del observador
      var observerConfig = {
        childList: true,
        subtree: true
      };
  
      // Comenzar la observación
      observer.observe(document.body, observerConfig);
  
      // Detener la observación después de 5 segundos (por ejemplo)
      setTimeout(function () {
        observer.disconnect();
      }, 5000);
    }
  }

  export function searchElementsHidden(phoneRingpool, dataOptanon) {
    var classesToSearch = ['drp_ring_container'];
  
    // Función para comprobar si un elemento contiene alguna de las clases buscadas
    function containsClass(element) {
      for (var i = 0; i < classesToSearch.length; i++) {
        if (element.classList.contains(classesToSearch[i])) {
          return true;
        }
      }
      return false;
    }
  
    function hideElements(elements) {
      
      for (var i = 0; i < elements.length; i++) {
        const actualPhone=localStorage.getItem("inboundWalmeric")
      
             elements[i].innerHTML=addSpaces(actualPhone)
             elements[i].href="tel:"+ actualPhone;
              
      }
    }
  
    // Realizar búsqueda sin el observador
    var elements = document.querySelectorAll('.' + classesToSearch.join(', .'));
    if (elements.length > 0) {
      
      hideElements(elements);
    } else {
      // Crear un observador de mutaciones
      var observer = new MutationObserver(function(mutationsList, observer) {
        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var addedNode = mutation.addedNodes[j];
            if (addedNode.nodeType === Node.ELEMENT_NODE && containsClass(addedNode)) {
              hideElements(elements);
              observer.disconnect();
              return;
            }
          }
        }
      });
  
      // Configuración del observador
      var observerConfig = {
        childList: true,
        subtree: true
      };
  
      // Comenzar la observación
      observer.observe(document.body, observerConfig);
  
      // Detener la observación después de 5 segundos (por ejemplo)
      setTimeout(function() {
        observer.disconnect();
      }, 5000);
    }
  }



  export function  showElementsHidden(phoneRingpool, dataOptanon) {
    var classesToSearch = ['drp_ring_container'];
  
    // Función para comprobar si un elemento contiene alguna de las clases buscadas
    function containsClass(element) {
      for (var i = 0; i < classesToSearch.length; i++) {
        if (element.classList.contains(classesToSearch[i])) {
          return true;
        }
      }
      return false;
    }
  
    function showElements(elements) {
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'block !important';
      }
    }
  
    // Realizar búsqueda sin el observador
    var elements = document.querySelectorAll('.' + classesToSearch.join(', .'));
    if (elements.length > 0) {
      showElements(elements);
    } else {
      // Crear un observador de mutaciones
      var observer = new MutationObserver(function(mutationsList, observer) {
        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var addedNode = mutation.addedNodes[j];
            if (addedNode.nodeType === Node.ELEMENT_NODE && containsClass(addedNode)) {
              showElements(elements);
              observer.disconnect();
              return;
            }
          }
        }
      });
  
      // Configuración del observador
      var observerConfig = {
        childList: true,
        subtree: true
      };
  
      // Comenzar la observación
      observer.observe(document.body, observerConfig);
  
      // Detener la observación después de 5 segundos (por ejemplo)
      setTimeout(function() {
        observer.disconnect();
      }, 5000);
    }
  }


  